// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2421 ? "4286a96f" : chunkId) + "." + {"89":"9180e57e48af26e0","1697":"db275f7abb69ebb3","2421":"d0ca4502c9f77c63","2650":"2ac0919c2f81adf3"}[chunkId] + ".js";
};